import { create } from "zustand";

const SUPPORTED_LANGUAGES = ["pt", "en"];

const getInitialLanguage = () => {
  try {
    const saved = localStorage.getItem("trekkin_language");
    if (SUPPORTED_LANGUAGES.includes(saved)) return saved;
    localStorage.setItem("trekkin_language", "pt");
    return "pt";
  } catch {
    return "pt";
  }
};

const initialLanguage = getInitialLanguage();
if (typeof document !== "undefined") {
  document.documentElement.lang = initialLanguage;
}

export const useLanguageStore = create((set) => ({
  language: initialLanguage,
  setLanguage: (language) => {
    const normalized = SUPPORTED_LANGUAGES.includes(language) ? language : "pt";
    try {
      localStorage.setItem("trekkin_language", normalized);
      if (typeof document !== "undefined") {
        document.documentElement.lang = normalized;
      }
    } catch {}
    set({ language: normalized });
  },
}));
